<section class="container-style">
  <form [formGroup]="formCompanyCity">
    <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-12 col-12">
        <app-custom-audit-info [userNameCreate]="companyCityModel.userNameCreate"
          [createDate]="companyCityModel.createDate" [userNameUpdate]="companyCityModel.userNameUpdate"
          [updateDate]="companyCityModel.updateDate"
          [reserveSpace]="true"></app-custom-audit-info>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-4 col-6 mb-1">
        <app-custom-select formControlName="countryId" [labelText]="'País'" [list]="listCountries" [required]="true"
          [recovery]="true" (onChangeSelect)="getCountry($event)">
        </app-custom-select>
      </div>
      <div class="col-lg-12 col-md-12 col-sm-4 col-6 mb-1">
        <app-custom-autocomplete formControlName="departmentId" [labelText]="'Departamento'" [list]="listDepartments"
          [required]="true" [recovery]="true" (onChangeSelect)="getDepartment($event)">
        </app-custom-autocomplete>
      </div>
      <div class="col-lg-12 col-md-12 col-sm-4 col-6 mb-1">
        <app-custom-autocomplete formControlName="cityId" [labelText]="'Ciudad'" [list]="listCities" [required]="true"
          [recovery]="true" (onChangeSelect)="changeCity($event)">
        </app-custom-autocomplete>
      </div>
      <div class="col-lg-4 col-md-12 col-sm-4 col-6">
        <app-custom-input-text formControlName="alterCode" [labelText]="'Código'" [required]="true">
        </app-custom-input-text>
      </div>
      <div class="col-lg-12 col-md-12 col-sm-12 col-12 d-flex justify-content-end align-items-end mt-sm-2 mt-md-3">
        <app-custom-button [label]="'Guardar'" [severity]="'primary'" [variant]="undefined"
          (onClick)="send()"></app-custom-button>
      </div>
    </div>
  </form>
</section>